import type {ReactNode} from "react";
import {twJoin} from "tailwind-merge";
import {hasAValidStringValue, tw} from "@vesta/aergia/utilities/utilities";

export const MenuSectionHeading = ({children, textColor, className}: {children: ReactNode; textColor?: string; className?: string}) => {
    const textClassName = hasAValidStringValue(textColor) ? textColor : tw`text-ds-text-subtlest`;
    return <>{Boolean(children) && <div className={twJoin(textClassName, className, "text-ds-font-heading-xxsmall")}>{children}</div>}</>;
};
